// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"fn-z","slideIn":"gn-z"};